<template>
  <component
    :is="wrapper"
    v-if="condition"
    v-bind="wrapperProps"
  >
    <slot />
  </component>
  <slot v-else />
</template>

<script setup>
defineProps({
  condition: Boolean,
  wrapper: String, // HTML tag (ex: 'a', 'div')
  wrapperProps: Object,
});
</script>
